import React from 'react';
import { PromiseScreen } from '../screens/PromiseScreen';
import { WhyDifferScreen } from '../screens/WhyDifferScreen';
import { InputsScreen } from '../screens/InputsScreen';
import { PhenotypesScreen } from '../screens/PhenotypesScreen';
import { BridgeScreen } from '../screens/BridgeScreen';
import { QuizOverlay } from '../QuizOverlay';
import { BayesianOverlay } from '../BayesianOverlay';
import { bayesProbe as snak2Probe } from '../../data/snak2';
import { bayesProbe as snak3Probe } from '../../data/snak3';
import { WindowScreen } from '../screens/snak2/WindowScreen';
import { IrreversibilityScreen } from '../screens/snak2/IrreversibilityScreen';
import { ProactiveScreen } from '../screens/snak2/ProactiveScreen';
import { EmbedScreen } from '../screens/snak2/EmbedScreen';
import { PreventScreen } from '../screens/snak2/PreventScreen';
import { PrinciplesScreen } from '../screens/snak3/PrinciplesScreen';
import { FitToClinicScreen } from '../screens/snak3/FitToClinicScreen';
import { PilotScreen } from '../screens/snak3/PilotScreen';
import { PredictScreen } from '../screens/snak3/PredictScreen';
import { CoCreateScreen } from '../screens/snak3/CoCreateScreen';
import { EntryScreen } from '../screens/EntryScreen';
interface ScreenThumbProps {
  id: string;
  snak: 0 | 1 | 2 | 3;
  /** Rendered width of the thumbnail in pixels. */
  width?: number;
}

/** Native size of the phone content area the screens are designed against. */
const BASE_W = 400;
const BASE_H = 570;
const noop = () => undefined;
function screenFor(id: string) {
  switch (id) {
    case 'entry-cover':
      return <EntryScreen onStartCampaign={noop} onStartPresentation={noop} onOpenJourney={noop} onOpenStoryboard={noop} previewState="cover" data-id="element-832" data-mp="1cytyfrxw8n69" />;
    case 'entry-menu':
      return <EntryScreen onStartCampaign={noop} onStartPresentation={noop} onOpenJourney={noop} onOpenStoryboard={noop} previewState="menu" data-id="element-833" data-mp="130nw5986df0v" />;
    case 'promise':
      return <PromiseScreen data-id="element-834" data-mp="owf5dwhtxfoj" />;
    case 'whyDiffer':
      return <WhyDifferScreen data-id="element-835" data-mp="k33yxwgxj0x5" />;
    case 's1-quiz-question':
      return <QuizOverlay onClose={noop} previewState="question" data-id="element-836" data-mp="f4j7omjnnrku" />;
    case 's1-quiz-result':
      return <QuizOverlay onClose={noop} previewState="result" data-id="element-837" data-mp="a5prgmczhmgz" />;
    case 'inputs':
      return <InputsScreen onAdvance={noop} data-id="element-838" data-mp="a3v99ft3k8gl" />;
    case 'phenotypes-cl1':
      return <PhenotypesScreen previewIndex={0} data-id="element-839" data-mp="17sycyhcziviz" />;
    case 'phenotypes-cl2':
      return <PhenotypesScreen previewIndex={1} data-id="element-840" data-mp="12vexje4jwcpg" />;
    case 'phenotypes-cl3':
      return <PhenotypesScreen previewIndex={2} data-id="element-841" data-mp="xur64rcettup" />;
    case 'phenotypes-cl4':
      return <PhenotypesScreen previewIndex={3} data-id="element-842" data-mp="sw7kyt5n4m3e" />;
    case 'bridge':
      return <BridgeScreen onRestart={noop} data-id="element-843" data-mp="svxtf14y66vl" />;
    case 's2-window':
      return <WindowScreen data-id="element-844" data-mp="3imkmjfnji2ki" />;
    case 's2-irreversible':
      return <IrreversibilityScreen data-id="element-845" data-mp="3ij590h9il1l7" />;
    case 's2-probe-prior':
      return <BayesianOverlay probe={snak2Probe} onClose={noop} previewPhase="prior" data-id="element-846" data-mp="3dkvbi00bhowf" />;
    case 's2-probe-evidence':
      return <BayesianOverlay probe={snak2Probe} onClose={noop} previewPhase="evidence" data-id="element-847" data-mp="1t2b0sfe4pjmx" />;
    case 's2-probe-update':
      return <BayesianOverlay probe={snak2Probe} onClose={noop} previewPhase="posterior" data-id="element-848" data-mp="232jzq0zi9j60" />;
    case 's2-proactive-cl1':
      return <ProactiveScreen previewIndex={0} data-id="element-849" data-mp="27tsap1ghhcla" />;
    case 's2-proactive-cl2':
      return <ProactiveScreen previewIndex={1} data-id="element-850" data-mp="2csdch5bdw4bu" />;
    case 's2-proactive-cl3':
      return <ProactiveScreen previewIndex={2} data-id="element-851" data-mp="2cufzrhl5jjcv" />;
    case 's2-proactive-cl4':
      return <ProactiveScreen previewIndex={3} data-id="element-852" data-mp="2gsdoykexa5g9" />;
    case 's2-embed':
      return <EmbedScreen data-id="element-853" data-mp="2lsryk6w69nge" />;
    case 's2-prevent':
      return <PreventScreen data-id="element-854" data-mp="2lqypym200t5r" />;
    case 's3-principles':
      return <PrinciplesScreen data-id="element-855" data-mp="2qr38siqdpzz5" />;
    case 's3-fit':
      return <FitToClinicScreen data-id="element-856" data-mp="2qps6kncl10a5" />;
    case 's3-probe-prior':
      return <BayesianOverlay probe={snak3Probe} tone="dark" onClose={noop} previewPhase="prior" data-id="element-857" data-mp="rgld8f9kdqad" />;
    case 's3-probe-evidence':
      return <BayesianOverlay probe={snak3Probe} tone="dark" onClose={noop} previewPhase="evidence" data-id="element-858" data-mp="2muytu9nygemr" />;
    case 's3-probe-update':
      return <BayesianOverlay probe={snak3Probe} tone="dark" onClose={noop} previewPhase="posterior" data-id="element-859" data-mp="2hvm7rr4wrbl8" />;
    case 's3-pilot':
      return <PilotScreen data-id="element-860" data-mp="2vtkk6qzo4xy3" />;
    case 's3-predict':
      return <PredictScreen data-id="element-861" data-mp="2rvd5e1orm6pj" />;
    case 's3-cocreate':
      return <CoCreateScreen onRestart={noop} data-id="element-862" data-mp="244qwk86xsieh" />;
    default:
      return null;
  }
}
const SURFACE: Record<number, string> = {
  0: 'bg-paper',
  1: 'bg-paper',
  2: 'bg-ozMist/50',
  3: 'bg-ozNavy'
};

/** Overlay states fill the frame themselves and need no content padding. */
const OVERLAY_IDS = ['s1-quiz-question', 's1-quiz-result', 's2-probe-prior', 's2-probe-evidence', 's2-probe-update', 's3-probe-prior', 's3-probe-evidence', 's3-probe-update'];
export function ScreenThumb({
  id,
  snak,
  width = 132
}: ScreenThumbProps) {
  const scale = width / BASE_W;
  const isOverlay = OVERLAY_IDS.includes(id);
  return <div className={`relative shrink-0 overflow-hidden rounded-lg border border-line ${SURFACE[snak]}`} style={{
    width,
    height: BASE_H * scale
  }} aria-hidden="true" data-id="element-863" data-mp="16ay9gkhox3b0">
      <div className={`pointer-events-none absolute left-0 top-0 flex flex-col ${isOverlay ? '' : 'px-6 pb-5 pt-3'}`} style={{
      width: BASE_W,
      height: BASE_H,
      transform: `scale(${scale})`,
      transformOrigin: 'top left'
    }} data-id="element-864" data-mp="wdk53j91k4z2">
        {screenFor(id)}
      </div>
    </div>;
}